module.exports = __webpack_public_path__ + "img/login-logo.ae584126.png";